module.exports = __webpack_public_path__ + "img/hc_pro_night_7.b61b30ff.jpg";